import React from 'react';
import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export const ProFeatureGate = ({ children, feature }) => {
  const { isPro, isAuthenticated } = useAuth();
  const { t } = useLanguage();

  if (isPro()) {
    return children;
  }

  return (
    <div className="relative">
      {/* Blurred content preview */}
      <div className="blur-sm pointer-events-none select-none opacity-50">
        {children}
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 flex items-center justify-center bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm rounded-xl">
        <div className="text-center p-8 max-w-md">
          <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-accent" />
          </div>
          <h3 className="font-heading font-bold text-xl text-slate-900 dark:text-white mb-2">
            {t('common_pro_required')}
          </h3>
          <p className="text-slate-500 dark:text-slate-400 mb-6">
            {feature}
          </p>
          {isAuthenticated ? (
            <Link
              to="/pricing"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium bg-accent text-white hover:bg-accent-hover transition-colors btn-press"
              data-testid="upgrade-btn"
            >
              {t('common_upgrade')}
            </Link>
          ) : (
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/register"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium bg-accent text-white hover:bg-accent-hover transition-colors btn-press"
                data-testid="register-upgrade-btn"
              >
                {t('nav_register')}
              </Link>
              <Link
                to="/login"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors"
                data-testid="login-upgrade-btn"
              >
                {t('nav_login')}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
